<template>
    <div>
        <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
            <!-- Card stats -->
            <b-row> </b-row>
        </base-header>
        <b-container fluid class="mt--7">
            <b-row class="justify-content-center">
                <b-col lg="12">
                    <card header-classes="bg-transparent">
                        <b-row class="mb-4">
                            <b-col cols="12" class="mb-4">
                                <h2 slot="header" class="mb-0">รายละเอียดรถ</h2>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="12">
                                <b-tabs content-class="mt-3" fill class="tab-manage-driver">
                                    <TabCar :carDetails="carDetails" :isLoadPage.sync="isLoadPage" />
                                    <TabHistory :isLoadPage.sync="isLoadPage" />
                                </b-tabs>
                            </b-col>
                        </b-row>
                    </card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import carServices from "@/api/car.service.js";
import TabCar from "@/components/Car/Tab/Car.vue"
import TabHistory from "@/components/Car/Tab/History.vue"

export default {
    components: { TabCar, TabHistory },
    data() {
        return {
            isLoadPage: false,
            carDetails: {
                vehicleCategory: null,
                vehiclePlate: null,
                province: null,
                brand: null,
                yearCreate: null,
                engineType: null,
                engineSize: null,
                driveSystem: null,
                status: null
            },
        };
    },
    async mounted() {
        await this.getCarDetails();
    },
    methods: {
        async getCarDetails(){
            try { 
                this.isLoadPage = true
                const response = await carServices.getCarDetailsById({ id: this.$route.params.id });
                const {
                    vehicleCategory,
                    plate,
                    engine_size,
                    engine_type,
                    brand,
                    drive_system,
                    province,
                    year_created,
                    status
                } = response.data.data;
                
                this.carDetails = {
                    vehicleCategory: vehicleCategory ? vehicleCategory : null,
                    vehiclePlate: plate,
                    province: province,
                    brand: brand,
                    yearCreate: year_created,
                    engineType: engine_type,
                    engineSize: engine_size,
                    driveSystem: drive_system,
                    status: status
                }
            }catch( error ){}
            finally{ this.isLoadPage = false }
        },
    }
}
</script>
